export const BOOKING_HEADERS = [
    'Booking No.',
    'Booking Date',
    'Travel Date',
    'Customer',
    'Product ID',
    'Product Name',
    'Product Type',
    'Price (THB)',
    'Amount',
    'Total (THB)'
]

export const WALLET_HEADERS = [
    'Pocket ID',
    'Customer',
    'Activation Date',
    'Transaction Ref. No.',
    'Transaction Date',
    'Detail',
    'Amount'
]

export const WRISTBAND_HEADERS = [
    'Wristband ID',
    'Wristband Name',
    'Activation Date',
    'Transaction Ref. No.',
    'Transaction Date',
    'Detail',
    'Amount'
]
